import type { ReactNode } from "react"

// The accent phrase in a headline. Owns its leading space, and carries no colour: blue is
// reserved for the two places that make the money claim — the hero rotor and the $0 in the
// payment heading — and spending it on fifteen headings drained the signal those depend on.
export const HeadingMark = ({ children }: { children: ReactNode }) => <span> {children}</span>

export const MoneyMark = ({ children }: { children: ReactNode }) => <span className="text-brand">{children}</span>
